export default __webpack_public_path__ + "static/media/caleb-forum-icon.703ee786.svg";